import React, { useState, useEffect, useRef, Fragment } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import ContainerReport from '../../../../../../pages/Builder/Analyze/ContainerReport';
import { getBotSessionsGraphic } from '../../../../../../store/actions/reports';
import iconData from '../../../../../../assets/images/data.svg';
import {
  getFilterPeriodType,
  updateChartXCategories,
  getTotalGraphic,
} from '../../graphic-report-helper';

const CHART_INITIAL_STATE = {
  chart: {
    type: 'column',
    width: 850,
    height: 250,
    style: {
      fontFamily: 'Fira Sans',
    },
  },

  title: {
    text: '',
  },

  xAxis: {
    categories: [],
  },

  yAxis: {
    min: 0,
    title: {
      text: '',
    },
  },

  tooltip: {
    useHTML: true,
    opacity: 1,
    backgroundColor: '#2B323D',
    borderColor: '#2B323D',
    borderRadius: 10,
    formatter() {
      if (this.y <= 0) {
        return false;
      }
      return `<table style="color: white;"><tr><td style="text-align: center;">${this.x}</td></tr><tr><td style="text-align: center; color: white;">${this.y}</td></tr><tr><td style="text-align: center; color: white;">${this.series.name}</td></tr></table>`;
    },
  },

  plotOptions: {
    column: {
      pointPadding: 0.4,
      borderRadius: 4,
      borderWidth: 0,
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      borderRadius: 5,
    },
  },
  series: [
    {
      name: 'total',
      data: [],
      stack: 'male',
      color: '#F47500',
      minPointLength: 5,
    },
  ],
  exporting: {
    enabled: false,
  },
};

/**
 * Component for show the graphic on the bot sessions report
 *
 * @param {*} props
 * @returns
 */
const QntSessionGraphic = (props) => {
  const {
    match,
    user,
    getBotSessionsGraphic,
    graphic,
    hideDownload,
    componentData,
    getRefGraphic,
    bot
  } = props;

  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  /** Object for configuration the Highcharts graphic */
  const [chartOptions, setChartOptions] = useState(CHART_INITIAL_STATE);
  const [timezone, setTimezone] = useState('');
  const refChartContainer = useRef(null);

  useEffect(() => {
    getRefGraphic(refChartContainer);
  });

  /**
   * Called for fetch new data for this component
   */

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  },[bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getBotSessionsGraphic(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone
      });
    }
  }, [parentFilter, user, timezone]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    updateChart();
  }, [graphic]);

  /**
   * Update chart when some information change
   */
  const updateChart = () => {
    const difference = moment.duration(
      moment(endDate.toString()).diff(moment(startDate.toString()))
    );
    const period = getFilterPeriodType(difference);
    const series = updateChartSeries(period);
    const categories = updateChartXCategories(period, graphic);

    const chart = {
      ...chartOptions,
      series,
      xAxis: {
        categories,
      },
    };

    setChartOptions(chart);
  };

  /**
   * Update the series property from the chart options object
   */
  const updateChartSeries = (period) => {
    const series = [];
    _.forEach(chartOptions.series, (element) => {
      const newElement = _.cloneDeep(element);
      newElement.data = _.map(getTotalGraphic(graphic, period), 'count');
      series.push(newElement);
    });
    return series;
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <HighchartsReact
        ref={refChartContainer}
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate
      />
    );
  };

  return (
    <ContainerReport
      type="graphic"
      icon={iconData}
      title="Quantidade de Sessões"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    graphic: state.reports.botSessionsGraphic,
    bot: state.bots.bot
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getBotSessionsGraphic }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QntSessionGraphic)
);
